import React from "react";
import styles from './modal.module.css';
import {Modal as BootStrapModal} from "react-bootstrap";
import {PrimaryButton, SecondaryButton, DangerButton} from "../input/inputs";
import {useTranslation} from "react-i18next";

export default function Modal({show, setter, name, description, children, buttonName, onClick, hideCancel, danger}) {
    const {t} = useTranslation();
    return (
        <BootStrapModal show={show} className={styles.container} centered={true}>
            <div className={styles.header}>
                <div className={styles.headerRow}>
                    <div>{name}</div>
                    {setter && <div className={styles.closeButton} onClick={() => setter(false)}>&times;</div>}
                </div>
                {description && <div>{description}</div>}
            </div>

            <div className={styles.body}>
                {children}
            </div>

            <div className={styles.footer}>
                {!hideCancel && <SecondaryButton onClick={() => setter(false)} name={t('common.cancel')}/>}
                {buttonName && <div className={'ms-3'}>
                    {danger ? (
                        <DangerButton name={buttonName} onClick={onClick}/>
                    ) : (
                        <PrimaryButton name={buttonName} onClick={onClick}/>
                    )}
                </div>}
            </div>
        </BootStrapModal>
    );
}